'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { ClientProvider } from './client';
import { SessionProvider } from './session';
import { AppSessionProvider } from './appSession';
import { ContainerProvider } from './container';

export { useClient } from './client';
export { useSession } from './session';
export { useService, BaseService } from './service';

export const ApiProvider = ({
  initialSession,
  swrConfig,
  appRouter,
  children,
}) => {
  return (
    <ContainerProvider>
      <ClientProvider initialSession={initialSession} swrConfig={swrConfig}>
        {appRouter ? (
          <AppSessionProvider>{children}</AppSessionProvider>
        ) : (
          <SessionProvider>{children}</SessionProvider>
        )}
      </ClientProvider>
    </ContainerProvider>
  );
};

ApiProvider.propTypes = {
  appRouter: PropTypes.bool,
  initialSession: PropTypes.object,
  swrConfig: PropTypes.object,
  children: PropTypes.node,
};
